import React from "react";
import { TB } from "../../Constants";
import * as BS from "react-bootstrap";

type FlatLabelInputProps = {
    label: string;
    className?: string;
    required?: boolean;
    labelWidth?: number;
    children?: React.ReactNode;
    align_items?: "center" | "start";
}

const FlatLabelInput: React.FC<FlatLabelInputProps> = props => {

    const class_name = React.useMemo(() => {
        const classes = ["mb-2"];
        const align = props.align_items || "center";
        if (props.className) classes.push(props.className);
        classes.push("align-items-" + align);
        return classes.join(" ");
    }, [props.align_items, props.className]);

    return <BS.Row className={class_name}>
        <BS.Col md={TB.getNumber(props.labelWidth, 3)}>
            <BS.Form.Label className="m-0">
                {props.label}
                {props.required && <span className="text-danger ms-2">*</span>}
            </BS.Form.Label>
        </BS.Col>
        <BS.Col md={12 - TB.getNumber(props.labelWidth, 3)}>
            {props.children}
        </BS.Col>
    </BS.Row>;
}

export default FlatLabelInput;